import React, { useState, useEffect } from "react";
import { IoEyeOutline } from "react-icons/io5";
import { BsDownload } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import { CiCircleAlert } from "react-icons/ci";
import { FaLessThan } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import Instance from "../../AxiosConfig";
import axios from "axios";
import ImgCrop from "antd-img-crop";
import { message, Upload } from "antd";

const ViewIndividualPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [certificationData, setCertificationData] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalFile, setModalFile] = useState(null);
  const [showDownloadToast, setShowDownloadToast] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showDeleteToast, setShowDeleteToast] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("You can only upload image files!");
      return Upload.LIST_IGNORE;
    }
    setImageUrl(URL.createObjectURL(file));
    return false; // prevent auto upload
  };
  // Fetch Certification Details
  const fetchCertificationData = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await Instance.get(`/individualCertification/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200 || response.status === 201) {
        const data = response.data.certification;
        setCertificationData(data);
        if (data.logo) setImageUrl(data.logo);
        if (data.attachments?.length > 0) {
          console.log("Attachments from API:", data.attachments); // Debug log

          const formattedFiles = data.attachments.map((file) => ({
            name: file.fileName,
            type: file.fileType,
            url: file.fileUrl?.startsWith("http")
              ? file.fileUrl
              : `${process.env.REACT_APP_BASE_URL || ""}${file.fileUrl}`,
            date: new Date(file.uploadedAt || Date.now()).toLocaleDateString(),
          }));

          setUploadedFiles(formattedFiles);
        } else {
          console.log("No attachments found in API response.");
        }
      }
    } catch (error) {
      console.error("Error fetching certification:", error.response || error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCertificationData();
  }, []);

  const handleBackButton = () => navigate("/certification");

  // ✅ Download file
  const handleDownload = async (file) => {
    if (!file?.url) return;
    try {
      const response = await axios.get(file.url, {
        responseType: "blob",
      });

      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = file.name || "downloaded_file"; // triggers browser's "save as"
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

      setShowDownloadToast(true);
      setTimeout(() => setShowDownloadToast(false), 3000);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleView = (file) => {
    setModalFile(file);
    setShowModal(true);
  };

  const handleDeleteConfirm = () => {
    setShowDeleteConfirm(false);
    setShowDeleteToast(true);
    setTimeout(() => setShowDeleteToast(false), 3000);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toISOString().split("T")[0];
  };

  return (
    <div>
      {/* <CompanyDataList /> */}
      {/* Toasts */}
      {showDownloadToast && (
        <div className="download-toast">
          <span>File downloaded successfully</span>
          <button
            className="toast-close-btn"
            onClick={() => setShowDownloadToast(false)}
          >
            <RxCross2 size={18} />
          </button>
        </div>
      )}
      {showDeleteToast && (
        <div className="download-toast">
          <span>File deleted successfully</span>
          <button
            className="toast-close-btn"
            onClick={() => setShowDeleteToast(false)}
          >
            <RxCross2 size={18} />
          </button>
        </div>
      )}
      <div className="company-form mt-4 p-4">
        <div className="details-header">
          {/* Logo Section */}
          <div className="logo-wrapper">
            <ImgCrop rotationSlider aspect={1} shape="round" quality={1}>
              <Upload
                name="logo"
                listType="picture-circle"
                className="avatar-uploader"
                showUploadList={false}
                beforeUpload={() => false}
              >
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt="Company Logo"
                    className="profile-img-preview"
                    draggable={false}
                    readOnly
                  />
                ) : (
                  <div>Upload</div>
                )}
              </Upload>
            </ImgCrop>

            <div
              className="logo-overlay"
              onClick={(e) => e.stopPropagation()}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => e.preventDefault()}
            />
          </div>

          <div className="company-name-display">
            <label className="company-label">Company Name</label>
            <div className="company-name-text">
              {certificationData?.companyName || "N/A"}
            </div>
            <div className="company-address-text">
              {certificationData?.address || "N/A"}
            </div>
          </div>
        </div>
      </div>
      {/* Company Info */}
      <div className="company-form mt-4">
        {/* Your existing form fields */}
        <div className="row ">
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Company Name</label>
            <input
              className="input-placeholder form-control"
              type="text"
              value={certificationData?.companyName || ""}
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Agent</label>
            <input
              className="input-placeholder form-control"
              style={{ width: "100%" }}
              value={certificationData?.assignedAgent?.agentName || ""}
              readOnly
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Standard</label>
            <input
              className="input-placeholder form-control"
              type="text"
              value={certificationData?.standard || ""}
              readOnly
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Address</label>
            <input
              className="input-placeholder form-control"
              type="text"
              value={certificationData?.address || ""}
              readOnly
            />
          </div>
           <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Country</label>
            <input
              className="input-placeholder form-control"
              type="text"
              value={certificationData?.country || ""}
              readOnly
            />
          </div>
           <div className="col-lg-4 mt-2">
            <label className="input-label form-label">City</label>
            <input
              className="input-placeholder form-control"
              type="text"
              value={certificationData?.city || ""}
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Client Name</label>
            <input
              className="input-placeholder form-control"
              type="text"
              value={certificationData?.clientName || ""}
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Email</label>
            <input
              className="input-placeholder form-control"
              type="text"
              value={certificationData?.email || ""}
              readOnly
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Date of Registration
            </label>
            <input
              type="date"
              value={formatDate(certificationData?.dateOfRegistration)}
              className="readonly-date input-placeholder form-control"
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              1st Surveillance Audit
            </label>

            <input
              type="date"
              value={formatDate(certificationData?.firstSurveillanceAudit)}
              className="readonly-date input-placeholder form-control"
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              1st Survielence Audit Status
            </label>
            <input
              className="input-placeholder form-control"
              value={certificationData?.status || ""}
              style={{ width: "100%" }}
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              2nd Surveillance Audit
            </label>

            <input
              type="date"
              value={formatDate(certificationData?.secondSurveillanceAudit)}
              className="readonly-date input-placeholder form-control"
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              2nd Survielence Audit Status
            </label>
            <input
              className="input-placeholder form-control"
              value={certificationData?.secondSurveillanceStatus}
              style={{ width: "100%" }}
              readOnly
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Certification Expiry Date
            </label>

            <input
              type="date"
              value={formatDate(certificationData?.certificationExpiryDate)}
              className="readonly-date input-placeholder form-control"
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Certification Number
            </label>
            <input
              className="input-placeholder form-control"
              type="text"
              value={certificationData?.certificationNumber || ""}
              readOnly
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Status</label>
            <input
              className="input-placeholder form-control"
              value={certificationData?.status || ""}
              readOnly
              style={{ width: "100%" }}
            />
          </div>
        </div>
        <div className="col-lg-12 mt-3">
          <label className="input-label form-label">Scope of Work</label>
          <textarea
            className="input-placeholder form-control"
            placeholder="Enter scope of work..."
            rows={4} // height of the textarea
            value={certificationData?.scopeOfWork}
            readOnly
          />
        </div>
        <div className="col-lg-12 mt-3">
          <label className="input-label form-label">
            1st Survelliance Audit Notes
          </label>
          <textarea
            className="input-placeholder form-control"
            rows={4}
            value={certificationData?.firstSurveillanceNotes}
            readOnly
          />
        </div>
        <div className="col-lg-12 mt-3">
          <label className="input-label form-label">
            2nd Survelliance Audit Notes
          </label>
          <textarea
            className="input-placeholder form-control"
            rows={4} // height of the textarea
            value={certificationData?.secondSurveillanceNotes}
            readOnly
          />
        </div>
        Upload Section
        {/* File Details Table */}
        {uploadedFiles.length > 0 ? (
          <div className="table-responsive mt-4">
            <table className="file-table">
              <thead>
                <tr>
                  <th>File Name</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {uploadedFiles.map((file, index) => (
                  <tr key={index}>
                    <td>{file.name}</td>
                    <td>{file.type}</td>
                    <td>{file.date}</td>
                    <td className="file-actions">
                      <IoEyeOutline
                        onClick={() => handleView(file)}
                        style={{ cursor: "pointer" }}
                      />
                      <BsDownload
                        onClick={() => handleDownload(file)}
                        style={{ cursor: "pointer" }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-muted mt-4">No uploaded files found.</p>
        )}
        <div className="d-flex justify-content-end align-items-center gap-3 mt-4">
          {" "}
          <button className="save-btn" onClick={handleBackButton}>
            {" "}
            <FaLessThan style={{ fontSize: "10px" }} /> Back{" "}
          </button>{" "}
        </div>
      </div>
      {/* Delete Confirmation Modal */}{" "}
      {showDeleteConfirm && (
        <div
          className="delete-modal-overlay"
          onClick={() => setShowDeleteConfirm(false)}
        >
          {" "}
          <div
            className="delete-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            {" "}
            <div className="alert-content">
              {" "}
              <CiCircleAlert className="alert-icon" /> <h2>Are you sure?</h2>{" "}
              <p>This action cannot be undone.</p>{" "}
            </div>{" "}
            <div className="d-flex justify-content-around align-items-center gap-3 mt-4">
              {" "}
              <button
                className="cancel-btn"
                onClick={() => setShowDeleteConfirm(false)}
              >
                {" "}
                Cancel{" "}
              </button>{" "}
              <button className="delete-btn" onClick={handleDeleteConfirm}>
                {" "}
                Delete{" "}
              </button>{" "}
            </div>{" "}
          </div>{" "}
        </div>
      )}
      {showModal && modalFile && (
        <div
          className="image-modal-overlay"
          onClick={() => setShowModal(false)}
        >
          <div
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-close-btn"
              onClick={() => setShowModal(false)}
            >
              <RxCross2 />
            </button>

            {modalFile.type.includes("image") ? (
              <img src={modalFile.url} alt={modalFile.name} />
            ) : (
              <iframe
                src={modalFile.url}
                title={modalFile.name}
                style={{
                  width: "90vw",
                  height: "80vh",
                  border: "none",
                  display: "block",
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewIndividualPage;
